<template>
  <div class="register-container">
    <div class="card-top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="member">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="用户名" prop="username" class="text-hide">
          <el-input v-model.trim="form.username" placeholder="请设置用户名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="form.phone" placeholder="请输入手机号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input type="password" v-model.trim="form.password" placeholder="请设置密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password1">
          <el-input type="password" v-model.trim="form.password1" placeholder="请设置密码"></el-input>
        </el-form-item>
        <el-form-item label="注册省份" prop="province" >
          <!-- :value="form[form.province]" -->
          <el-select v-model="form.provinceOne"  @change="selectOne"
          placeholder="请选择考生所在省份" :disabled="registerDisabled">
            <el-option
              v-for="item in form.province"
              :key="item.code"
              :label="item.areaname"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="就读中学" prop="city">
          <el-cascader
            ref="cascaderAddr"
            :options="options"
            @expand-change="handleChange"
            @change="changeSchool"
            :props="props"
            v-model="form.city"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="就读中学" prop="school" v-show="false">
          <el-input v-model.trim="form.school" placeholder="请选择学校"></el-input>
        </el-form-item>
        <!--   class="text-hide" -->
        <el-form-item label="首选科目" prop="sxkm">
          <el-select v-model="form.sxkm" placeholder="首选科目选择">
            <el-option label="历史（文科）" value="1"></el-option>
            <el-option label="物理（理科）" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业类别" prop="zylb">
          <el-select v-model="form.zylb" placeholder="请选择专业类别">
            <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="再选科目1" prop="zxkma">
          <el-select v-model="form.zxkma" placeholder="再选科目选择">
            <el-option :label="item.text" :value="item.value" v-for="(item,index) in zxkmOptions" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文化成绩" prop="wscore">
          <el-input v-model.number="form.wscore" placeholder="包含政策性加分成绩"></el-input>
        </el-form-item>
        <el-form-item label="再选科目2" prop="zxkmb">
          <el-select v-model="form.zxkmb" placeholder="再选科目选择">
            <el-option :label="item.text" :value="item.value" v-for="(item,index) in zxkmOptions" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业成绩" prop="zscore">
          <el-input v-model.number="form.zscore" placeholder="请输入专业成绩"></el-input>
        </el-form-item>
        <el-form-item label="高考年度" prop="year">
          <el-select v-model="form.year" placeholder="哪一年参加高考" >
            <el-option :label="item" :value="item" v-for="(item,index) in gaoKaoYear" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="xm">
          <el-input v-model.number="form.xm" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="xb">
          <el-radio-group v-model="form.xb">
            <el-radio :label="1" border>男</el-radio>
            <el-radio :label="2" border>女</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="省排名" prop="spm">
          <el-input v-model.number="form.spm" placeholder="请输入省排名"></el-input>
        </el-form-item> -->
        <el-form-item label="会员卡号" prop="cardNum">
          <el-input v-model="form.cardNum" placeholder="请输入金榜通卡号"></el-input>
        </el-form-item>
        <!--  style="width:100%;margin-left:11px;" 
          width:100%;margin:0;margin-bottom: 30px;margin-left: 9px;-->
        <el-form-item label="卡号密码" prop="cardPwd">
          <el-input type="password" v-model="form.cardPwd" placeholder="请输入卡号密码" style="width:313px;margin-left:0" 
          ></el-input>
          <!-- style="width:41.4%;" -->
        </el-form-item>
        <el-form-item label="户籍所在地" prop="hjszdText" style="width:98%">
          <!-- <el-select v-model="form.hjszd">
            
          </el-select> -->
          <el-input v-model="form.hjszdText" size="small" style="width:313px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px;">
          <el-checkbox v-model="checked">我已阅读并接受<a href="/#/userxx" target="_blank"
              style="text-decoration: none;color: #5BC0DE;">《用户使用协议》</a></el-checkbox>
        </el-form-item>
        <el-form-item style="margin-left:232px;">
          <el-button type="primary" @click="submitForm('form')" class="register-btn">立即注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getRegister, getAreaAll, getSchool, getZyTypes } from "../../../api/index";
import {getShixian, getSchools} from "../../../api/newExam";
export default {
  name: "Register",
  data() {
    // 验证两次再选科目不能相同
    const confirmPwd = (rule, value, callback) => {
      if(value === '') {
        callback(new Error("请选择再选科目，注意再选科目不能重复选择!"));
      }else if(value === this.form.zxkma) {
        callback(new Error("科目不能重复选择"));
      }else {
        callback();
      }
    };
    return {
      form: {
        username: null, //用户名
        password: "", //密码
        phone: "", //手机号
        province: [{
          areaname: "湖南省",
          code: "43",
          isopen: 1,
          status: 0,
          supercode: "0"
        }], 
        //省份对象
        proValue:"",
        provinceOne: "43", //选中省份
        city: [],
        school: null, //学校
        sxkm: "", //首选科目
        zxkma: "", // 再选科目A
        zxkmb: "", // 再选科目B
        zylb: "", //专业类别
        wscore: "", //文化成绩
        zscore: "", //专业成绩
        year: "", //年度
        cardNum: "", //会员卡号
        cardPwd: "", //卡号密码
        xm:"",
        xb:"",
        spm:"",
        password1:"",
        zxxh:"",
        hjszd:0,
        hjszdText:''
      },
      zylbOptions:[], // 专业列表
      gaoKaoYear:[], // 年度列表
      zxkmOptions: [
        {text: '政治', value: 1},
        {text: '地理', value: 2},
        {text: '化学', value: 3},
        {text: '生物', value: 4},
        ],
      rules: {
        username: [
          { required: false, message: "请输入用户名", trigger: "change" }
        ],
        password: [{ required: true, message: "请输入系统登录密码", trigger: "change" }],
        phone: [
          { required: true, message: "请输入您的手机号码", trigger: "change" },
          { pattern: /^1[345789]\d{9}$/, message: "请输入正确的手机号码" }
        ],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择地区", trigger: "blur" }],
        school: [{ required: true, message: "请选择学校", trigger: "change" }],
        sxkm: [{ required: true, message: "请选择科目", trigger: "change" }],
        zylb: [{ required: true, message: "请选择专业类别", trigger: "change" }],
        zxkma: [{required: true, message: "请选择再选科目，注意再选科目不能重复选择", trigger: "change" }],
        zxkmb: [{required: true, validator: confirmPwd, trigger: "change" }],
        wscore: [{ required: true, message: "请输入您的文化成绩", trigger: "change" }],
        zscore: [{ required: true, message: "请输入您的专业成绩", trigger: "change" }],
        year: [{ required: true, message: "请选择您的高考年度", trigger: "change" }],
        cardNum: [
          { required: true, message: "请输入您的会员卡号", trigger: "change" },
          { min: 10, message: "卡号格式错误", trigger: "change" }
          ],
        cardPwd: [{required: true, message: "请输入您的卡号密码", trigger: "change"}],
        password1: [{required: true, message: "请再次输入密码", trigger: "change"}],
        xm: [{required: true, message: "请输入您的姓名", trigger: "change"}],
        xb: [{required: true, message: "请选择性别", trigger: "change"}],
        spm: [{required: true, message: "请输入您的省排名", trigger: "change"}],
        // hjszdText:[{required:true,message:'请输入户籍所在地',trigger:'blur'}]  
      },
      checked:false,
      options: [],
      // props: {
      //   value: "code",//地级代号
      //   label: "areaname",//地级名称
      //   children: "child"//子集
      // }
      module:{},
      module2:{},
      registerDisabled:true,
      props:{
        value:"dqbm",
        label:"dqmc",
        children:"child"
      }
    };
  },
  methods: {
    //提交表单
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          const checked=this.checked;
          if(!checked){
            this.$message({message:'请勾选好协议再注册',type:'warning',showClose:true});
            return;
          }
          this.form.username = this.form.phone;
          const salt="cvdf-yyds*123.cv987@";
          // const result = await getRegister(
          //   this.form.username,
          //   this.$md5(salt+this.form.password),
          //   this.form.phone,
          //   this.form.provinceOne,
          //   this.form.school,
          //   this.form.sxkm,
          //   this.form.zylb,
          //   this.form.wscore,
          //   this.form.zscore,
          //   this.form.year,
          //   this.form.cardNum,
          //   this.form.cardPwd,
          //   this.form.zxkma,
          //   this.form.zxkmb
          // );
          const result=await this.$http.postHttp("/users/register",{
            username:this.form.username,
            password:this.$md5(this.form.password),
            password1:this.$md5(this.form.password1),
            sjhm:this.form.phone,
            sssf:this.form.provinceOne,
            xxmc:this.form.school,
            school:this.form.zxxh,
            sxkm:this.form.sxkm,
            kl:this.form.sxkm,
            zylb:this.form.zylb,
            wscore:this.form.wscore,
            zscore:this.form.zscore,
            gkfs:this.form.wscore,
            nd:this.form.year,
            year:this.form.year,
            zckh:this.form.cardNum,
            khmm:this.form.cardPwd,
            cardPwd:this.form.cardPwd,
            zxkma:this.form.zxkma,
            zxkmb:this.form.zxkmb,
            xm:this.form.xm,
            xb:this.form.xb,
            spm:this.form.spm,
            hjszd1:this.form.hjszdText,
            yhlb:"2",
            type:2,
            // type:3
          });
        if (result.data.code === 200) {
            this.$message({
              type: "success",
              message: `注册成功`,
              duration: "2000"
            });
            setTimeout(() => {
              this.$router.replace("/main/home");
            }, 2000);
        }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.message,type:'error'});
            }
        }else if(result.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
        }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        } else {
            this.$message.error(`${result.msg}`);
          }
        } else {
          return false;
        }
      });
    },
    async getApiIndexMethod(){
                const flag=this.$apiFlag;
                if(flag===1||flag===3){
                    this.module=await import("../../../api/index");
                    this.module2=await import("../../../api/newExam");
                }else if(flag===2){
                    this.module=await import("../../../api/index22");
                    this.module2=await import("../../../api/newExam11");
                }
    },
    //获取市区学校
    handleChange(value) {
      //3.加载区
      let parentId;
      if (value.length === 1) {
        // 如果点击的是一级分类
        parentId = value[0];
        this.options.map(async (item, index) => {
          if (item.dqbm === parentId && item.child.length === 0) {
            // item.code === parentId
            // 当顶级分类的的child为空时才请求数据
            // let arrQu = await getAreaAll(parentId, 3, 0);
            // if (arrQu.code === 200) {
            //   this.$set(this.options[index], "child", arrQu.data);
            //   item.child.map((innerItem, innerIndex) => {
            //     // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
            //     this.$set(item.child[innerIndex], "child", []);
            //   });
            // }
            let arrQu = await this.module2.getShixian(parentId);
            if(arrQu.data.code===200){
              this.$set(this.options[index],"child",arrQu.data.obj)
              item.child.map((innerItem,innerIndex)=>{
                this.$set(item.child[innerIndex],"child",[]);
              })
            }else if(arrQu.data.code===500){
            if(arrQu.data.message){
                this.$message({message:arrQu.data.message,type:'error'});
            }else if(arrQu.data.msg){
              this.$message({message:arrQu.data.message,type:'error'});
            }
            }else if(arrQu.status===401){
                  // this.$message({message: '登录超时，请重新登录',type:"error"});
                  // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  // this.$router.replace({
                  //     path: '/main/home',
                  //     query: {redirect: this.$router.currentRoute.fullPath}
                  // });
            }else if(arrQu.data.code===0){
                  this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                  await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  this.$router.replace({
                      path: '/main/home',
                      query: {redirect: this.$router.currentRoute.fullPath}
                  });
            }else if(arrQu.status===409||arrQu.status===410||arrQu.status===411){
                  this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                  await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  this.$router.replace({
                      path: '/main/home',
                      query: {redirect: this.$router.currentRoute.fullPath}
                  });
            }
          }
        });
      } else {
        parentId = value[1];
        this.options.map((item, index) => {
          item.child.map(async (innerItem, innerIndex) => {
            if (innerItem.dqbm === parentId && innerItem.child.length === 0) {
              // innerItem.code === parentId
              // 当二级分类的的child为空时才请求一次数据
              // let school = await getSchool(parentId);
              // if (school.code === 200) {
              //   let arrSchool = [];
              //   arrSchool = school.data.map((s,i)=>{
              //      return {code: s.schcode, areaname: s.schname}
              //    });
              //   this.$set(item.child[innerIndex], "child", arrSchool);
              // }
              let school = await this.module2.getSchools(parentId);
              if(school.data.code===200){
                let arrSchool = [];
                arrSchool = school.data.obj.map((s,i)=>{
                  return {dqbm:s.zxxh,dqmc:s.zxmc}
                })
                this.$set(item.child[innerIndex],"child",arrSchool)
              }else if(school.data.code===500){
                if(school.data.message){
                    this.$message({message:school.data.message,type:'error'});
                }else if(school.data.msg){
                  this.$message({message:school.data.message,type:'error'});
                }
              }else if(school.status===401){
                    // this.$message({message: '登录超时，请重新登录',type:"error"});
                    // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    // this.$router.replace({
                    //     path: '/main/home',
                    //     query: {redirect: this.$router.currentRoute.fullPath}
                    // });
              }else if(school.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(school.status===409||school.status===410||school.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }
            }
          });
        });
      } 
    },
    //获取选中的学校并赋值
    changeSchool(val){
      let schoolArr,paramsStr='';
      schoolArr =this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels;
      const schoolXh=this.$refs.cascaderAddr.getCheckedNodes()[0].value;
      this.form.zxxh=schoolXh;
      schoolArr.map((item,i)=>{
        paramsStr += item + '/'
      });
      if(paramsStr !==''){
          paramsStr = paramsStr.substr(0,paramsStr.lastIndexOf('/'));
        }
      this.form.school =  paramsStr;
    },
    //高考年度设置
    _getGaoKaoYear(){
      let nowDate = new Date().getFullYear();
      let month  = new Date().getMonth();
      if(month >= 6) {
        // 过完7月注册年度从下一年开始
        this.gaoKaoYear.push(nowDate + 1);
        this.gaoKaoYear.push(nowDate + 2);
        this.gaoKaoYear.push(nowDate + 3);
      }else {
        this.gaoKaoYear.push(nowDate);
        this.gaoKaoYear.push(nowDate + 1);
        this.gaoKaoYear.push(nowDate + 2);
      }
     
    },
    //初始化省份
    async _initProvince() {
      //1.加载省份
      const provinces = await this.module.getAreaAll(0, 1, 1); //(code,2,0)
      
      if (provinces.data.code === 200) {
        this.form.province = provinces.data.data;
      }else if(provinces.data.code===500){
            if(provinces.data.message){
                this.$message({message:provinces.data.message,type:'error'});
            }else if(provinces.data.msg){
              this.$message({message:provinces.data.message,type:'error'});
            }
      }else if(provinces.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
      }else if(provinces.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(provinces.status===409||provinces.status===410||provinces.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } else{
        this.$message.error('网络错误获取省份失败，请稍后再试');
      }
    },
    //初始化专业类别
    async _initZyTypes(){
      const zylbResult = await this.module.getZyTypes();
      if(zylbResult.data.code === 200){
        this.zylbOptions = zylbResult.data.data;
      }else if(zylbResult.data.code===500){
            if(zylbResult.data.message){
                this.$message({message:zylbResult.data.message,type:'error'});
            }else if(zylbResult.data.msg){
              this.$message({message:zylbResult.data.message,type:'error'});
            }
      }else if(zylbResult.status===401){
            // this.$message({message: '登录超时，请重新登录',type:"error"});
            // await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            // this.$router.replace({
            //     path: '/main/home',
            //     query: {redirect: this.$router.currentRoute.fullPath}
            // });
      }else if(zylbResult.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbResult.status===409||zylbResult.status===410||zylbResult.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
    },
    //根据省份选择学校
    async selectOne(event) {
      console.log(event);
      this.$set(this.form, this.form.province, event);
      //赋值选中的市代号
      this.form.provinceOne = event;
      // //2.加载市
      // let result = await getAreaAll(event, 2, 0);
      // this.options = result.data;
      // this.options.map((item, index, array) => {
      //   // 因为数组和对象更新后不会更新视图，这里必须用$set方法
      //   this.$set(array[index], "child", []);
      // });
      let result = await this.module2.getShixian(event);
      this.options = result.data.obj;
      this.options.map((item,index,array)=>{
        this.$set(array[index],"child",[]);
      });
    },
    async getCityByProvince(){
      const pro=this.form.provinceOne;
      let result = await this.module2.getShixian(pro);
      this.options = result.data.obj;
      this.options.map((item,index,array)=>{
        this.$set(array[index],"child",[]);
      });
    }
  },
  async mounted() {
    // this._initProvince();
    await this.getApiIndexMethod();
    await this._initZyTypes();
    await this._getGaoKaoYear();
    await this.getCityByProvince();
  }
};
</script>
<style lang="stylus" scoped>
.register-container 
  width 900px
  min-height calc(100vh - 410px)
  min-height -moz-calc(100vh - 410px)
  min-height -webkit-calc(100vh - 410px)
  margin 30px auto
  .card-top
    width 1200px
    margin 20px auto
 .member
    display flex
    justify-content center
    align-items center
    flex-flow nowrap
    width 100%
    .el-form
      display flex
      flex-wrap wrap
      box-sizing border-box
      background-color #fff
      border-radius 5px
      padding 50px 20px 20px
      .el-form-item
        width 48%
        margin 0 auto
        margin-bottom 30px
        .register-btn
          width 200px
        .el-cascader,.el-select
          width 100%
      .text-hide 
        display none    
</style>


